/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_ResubscribedInputs */

const en_plan_resubscribed = /** @type {(inputs: Plan_ResubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription resubscribed successfully`)
};

const es_plan_resubscribed = /** @type {(inputs: Plan_ResubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción renovada exitosamente`)
};

/**
* | output |
* | --- |
* | "Subscription resubscribed successfully" |
*
* @param {Plan_ResubscribedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_resubscribed = /** @type {((inputs?: Plan_ResubscribedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_ResubscribedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_resubscribed(inputs)
	return en_plan_resubscribed(inputs)
});